import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/order_history';

export default function OrdeHistory() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
